import { computed } from 'vue'
import { useUiToggleStore } from '@/store/uiToggleStore'

/**
 * Returns a computed component reference that switches
 * between old and new version based on the global toggle.
 * 
 * @param {object} oldComp - Old Vue component
 * @param {object} newComp - New Vue component
 */
export function useUiWrapper(oldComp, newComp) {
  const uiToggle = useUiToggleStore()

  return computed(() => (uiToggle.showNewUI ? newComp : oldComp))
}
